module.exports = __webpack_public_path__ + "img/kuangshan.6fc468fc.png";